/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { InfigoModule } from '@dm/live-material-infigo';
import { PipesModule } from 'app/common/pipes/pipes.module';
import { HyperMetroPairConst } from 'app/feature/protection/object/lun/hyper-metro/hyper-metro-pair-str-service';
import { HostsStrService } from 'app/feature/service/block-service/hosts/hosts-str.service';
import { PortGroupStrService } from 'app/feature/service/block-service/port-group/port-group-str.service';

import { LunService } from '../../service/block-service/lun-entry/lun/lun.service';
import { LunsConst } from '../../service/block-service/lun-group/luns.const';
import { ConditionPipe } from './condition.pipe';
import { GlobalInfigoModule } from './global-infigo/global-infigo.module';
import { GlobalSearchComponent } from './global-search.component';
import { GlobalSearchInputModule } from './global-search-input/global-search-input.module';
import { GlobalSearchListModule } from './global-search-list/global-search-list.module';
import { GlobalSearchStrService } from './global-search-str.service';


@NgModule({
    declarations: [GlobalSearchComponent, ConditionPipe],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        GlobalSearchListModule,
        GlobalSearchInputModule,
        InfigoModule,
        PipesModule,
        GlobalInfigoModule,
    ],
    exports: [GlobalSearchComponent],
    providers: [GlobalSearchStrService, HyperMetroPairConst, PortGroupStrService, HostsStrService, LunService, LunsConst],
})
export class GlobalSearchModule {
}
